import { cloneDeep } from 'lodash';
import AuthNPoliciesApi from 'client/api/v2/AuthNPoliciesApi';
import AuthNPolicy from 'client/Security/AuthNPolicyType';

import createModel from 'client/store/modules/models/createModel';

import Vue from 'vue';

const model = createModel(() => new AuthNPolicy(), 'id', AuthNPoliciesApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
    canSaveItem: true,
  },

  actions: {
    ...model.actions,

    // Overwritting fetchItem to get a custom initial values for a new item
    fetchItem: async ({ commit, getters }) => {
      if (getters.id) {
        const item = await AuthNPoliciesApi.fetchItem(getters.id);
        commit('SET_ITEM', cloneDeep(item));
        commit('SET_PREVIOUS_ITEM', cloneDeep(item));
      } else if (getters.isItemBeingCreated) {
        // Default a created item to be enabled
        // Not setting Previous Item because this value is just for the initial for state
        commit('SET_ITEM', { disabled: false });
      }
    },

    saveItem(context) {
      return model.actions.saveItem(context);
    },

    updateCanSaveItem({ commit }, payload) {
      commit('UPDATE_CAN_SAVE_ITEM', payload);
    },
  },

  getters: {
    ...model.getters,

    canSaveItem: state => state.canSaveItem,
    displayName: state => state.item.name,
  },

  mutations: {
    ...model.mutations,

    UPDATE_CAN_SAVE_ITEM(state, payload) {
      Vue.set(state, 'canSaveItem', payload);
    },
  },
};
